// extracted by mini-css-extract-plugin
export default {"wrapperRate":"UiRateRatingStar_wrapperRate","votes":"UiRateRatingStar_votes"};